module.exports = __webpack_public_path__ + "static/media/view-more.faf0dec3.svg";